import { createStore } from 'redux'
import rootReducer from './redux/reducer'
import { devToolsEnhancer } from 'redux-devtools-extension'

export default function configureStore() {
  const store = createStore(rootReducer, devToolsEnhancer({}))
  return store
}
